import moment from 'moment';

const FormatDate = (date: string, separator: string) => {
  return moment(date).format(`yyyy-MM-DD HH:mm`).replace(' ', separator);
};

export default FormatDate;
